import { AnySchema } from "yup/lib/schema";
import { useState, useEffect } from "react";

export const useYupValidation = (value: unknown, schema?: AnySchema) => {
  const [validationError, setValidationError] = useState<string | undefined>(undefined);
  const [showError, setShowError] = useState<boolean>(false);

  useEffect(() => {
    try {
      value && schema?.validateSync(value);
      setValidationError(undefined);
    } catch ({ message }) {
      setValidationError(message as string);
    }
  }, [value]);

  return {
    validationError,
    showError,
    setShowError,
  };
};
